import { change as changeFormValue } from 'redux-form';
import { connect } from 'react-redux';
import { SIMPLE_VISA } from '../../products';
import { getDisplayPrice, getSelected, getSelectedTraveler, getTravelerChoice, getTravelerField, getTravelersWithChoice, hasAnyTravelerSelected } from '../utils/selection';
import { getTravelerNames } from '../../common/utils/travelerNames';
import { getContactEmail } from '../../common/utils/travelerContacts';
import { getTravelers } from '../utils/simpleVisaTransformer';
import SimpleVisaLayout from '../components/SimpleVisaLayout';
const getCardSelection = cardSelectionRaw => {
  if (typeof cardSelectionRaw === 'string') {
    return cardSelectionRaw === 'true';
  }
  if (typeof cardSelectionRaw === 'boolean') {
    return cardSelectionRaw === true;
  }
  return null;
};
const updateTotalPrice = (dispatch, {
  form
}) => priceRaw => {
  dispatch(changeFormValue(form, `${SIMPLE_VISA.name}.value.priceRaw`, priceRaw));
};
const selectVisaTraveler = (id, form, value, dispatch) => {
  const travelerField = getTravelerField(id, SIMPLE_VISA.name);
  dispatch(changeFormValue(form, `${travelerField}.selected`, value));
};
const selectAllTravelers = (dispatch, {
  form
}) => (travelers, value) => {
  const selectedValue = Boolean(value);
  const hasAnySelected = travelers.some(traveler => traveler.isSelected === true);
  const isFirstSelection = !hasAnySelected;
  travelers.forEach(({
    id,
    hasChoice,
    isSelected
  }) => {
    if (hasChoice) {
      selectVisaTraveler(id, form, !selectedValue || isFirstSelection ? selectedValue : isSelected, dispatch);
    }
  });
};
const selectProduct = (dispatch, {
  form
}) => newValue => dispatch(changeFormValue(form, `${SIMPLE_VISA.name}.value.value`, newValue));
const selectTraveler = (dispatch, {
  form
}) => (id, value) => {
  selectVisaTraveler(id, form, value, dispatch);
};
const isPostbookingOrder = order => {
  return 'availableExtraProducts' in order;
};
const mapStateToProps = (state, {
  form,
  order,
  contactEmail,
  travelerLabel
}) => {
  var _order$availableExtra;
  const sellSpecification = isPostbookingOrder(order) ? (_order$availableExtra = order.availableExtraProducts) === null || _order$availableExtra === void 0 || (_order$availableExtra = _order$availableExtra.find(product => Number(product.id) === SIMPLE_VISA.id)) === null || _order$availableExtra === void 0 ? void 0 : _order$availableExtra.sellSpecification : order.sellSpecification;
  const {
    availableChoices
  } = sellSpecification;
  const travelerNames = getTravelerNames(form, state, order.travelers);
  const travelersWithChoice = getTravelersWithChoice(SIMPLE_VISA.name, form)(state);
  const travelers = getTravelers(order, travelerNames, travelerLabel, availableChoices).map(traveler => {
    const isSelected = getSelectedTraveler(SIMPLE_VISA.name, form, traveler.id)(state);
    const choice = getTravelerChoice(SIMPLE_VISA.name, form, traveler.id)(state);
    const hasChoice = travelersWithChoice.includes(traveler.id);
    return {
      ...traveler,
      hasChoice,
      isSelected,
      choice
    };
  });
  return {
    cardSelection: getCardSelection(getSelected(SIMPLE_VISA.name, form)(state)),
    contactEmail: getContactEmail(form, state) || contactEmail,
    hasAnySelected: hasAnyTravelerSelected(SIMPLE_VISA.name, form)(state),
    priceRaw: getDisplayPrice(SIMPLE_VISA.name, form)(state),
    travelers,
    isSelected: travelers.some(traveler => traveler.isSelected)
  };
};
const mapDispatchToProps = (dispatch, form) => ({
  selectProduct: selectProduct(dispatch, form),
  selectAllTravelers: selectAllTravelers(dispatch, form),
  updateTotalPrice: updateTotalPrice(dispatch, form),
  selectTraveler: selectTraveler(dispatch, form)
});
export default connect(mapStateToProps, mapDispatchToProps)(SimpleVisaLayout);
//# sourceMappingURL=SimpleVisaContainer.js.map